(() => {
  const initializeFilters = (root) => {
    if (!root || root.dataset.filtersReady === 'true') return;
    root.dataset.filtersReady = 'true';

    const tabs = [...root.querySelectorAll('[data-collection-tab]')];
    const panels = [...root.querySelectorAll('[data-collection-panel]')];

    const activateTab = (button) => {
      const target = button.dataset.collectionTab;
      tabs.forEach((tab) => {
        const active = tab === button;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.collectionPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) panel.querySelector('.ss-products')?.scrollTo({ left: 0 });
      });
    };

    root.addEventListener('click', (event) => {
      const scrollButton = event.target.closest('[data-product-scroll]');
      if (scrollButton && root.contains(scrollButton)) {
        const panel = scrollButton.closest('[data-collection-panel]');
        const track = panel?.querySelector('.ss-products');
        const card = track?.querySelector('.ss-product');
        if (track) {
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          track.scrollBy({ left: Number(scrollButton.dataset.productScroll) * distance, behavior: 'smooth' });
        }
        return;
      }

      const button = event.target.closest('[data-collection-tab]');
      if (button && root.contains(button)) activateTab(button);
    });

    root.addEventListener('keydown', (event) => {
      const button = event.target.closest('[data-collection-tab]');
      if (!button || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const current = tabs.indexOf(button);
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(current + direction + tabs.length) % tabs.length];
      next.focus();
      activateTab(next);
    });
  };

  const initializeWildGallery = (root) => {
    if (!root || root.dataset.wildReady === 'true') return;
    const track = root.querySelector('[data-wild-track]');
    const previous = root.querySelector('[data-wild-previous]');
    const next = root.querySelector('[data-wild-next]');
    if (!track) return;
    root.dataset.wildReady = 'true';

    const scrollByCard = (direction) => {
      const card = track.querySelector('.ss-wild__card');
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  };

  const initializeAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-spark-products]')) initializeFilters(scope);
    scope.querySelectorAll?.('[data-spark-products]').forEach(initializeFilters);
    if (scope.matches && scope.matches('[data-wild-gallery]')) initializeWildGallery(scope);
    scope.querySelectorAll?.('[data-wild-gallery]').forEach(initializeWildGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
